import { useCallback, useState } from 'react';

import { stripHtmlTags } from '@change-corgi/core/html';

import type { Comment } from 'src/app/pages/petition/comments/pageContext';
import { usePetitionCommentsPageData } from 'src/app/pages/petition/comments/pageContext';

type Result = ModelHookResult<
	{
		comment: string;
		commentUrl: string;
		expanded: boolean;
	},
	{
		expandComment: () => void;
	}
>;

export function useCommentCard({ id, comment }: Comment): Result {
	const [expanded, setExpanded] = useState(false);
	const {
		data: {
			petition: { slug },
		},
	} = usePetitionCommentsPageData();

	return {
		data: {
			// some comments somehow contain links in HTML format
			comment: stripHtmlTags(comment),
			commentUrl: `/p/${encodeURIComponent(slug)}/c/${id}`,
			expanded,
		},
		actions: {
			expandComment: useCallback(() => setExpanded(true), []),
		},
	};
}
